<template>
  <span>{{ displayAmount }}</span>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { toPersianDigits } from "@/core/utilities";

interface IProps {
  amount: number;
  cultureName: string;
  currencyCode: string;
}

const props = defineProps<IProps>();

const formattedAmount = computed(() =>
  new Intl.NumberFormat(props.cultureName, {
    currency: props.currencyCode,
    style: "currency",
  }).format(props.amount),
);

const displayAmount = computed(() => {
  // Convert to Persian digits for Persian locale
  if (props.cultureName === "fa" || props.cultureName === "fa-IR" || props.cultureName.startsWith("fa-")) {
    return toPersianDigits(formattedAmount.value);
  }
  return formattedAmount.value;
});
</script>
